import React from "react";
import "./style.css";
import image from "../../Assets/img/matic.png";
import arrow from "../../Assets/img/arrow-sm.png";

const RewardCard = (props) => {
  return (
    <div className="col-lg-2">
        <span className={`${props?.glow ? 'animate-glory overflow-hidden animate-span' : ''}`}></span>
      <span className="bar"></span>
      <h3>REWARD</h3>
      <div className="users">
        <h2>{props.rating}</h2>
        <img src={image} alt="" />
      </div>
      <a onClick={props.play}>
        Play {props?.price} Matic <img src={arrow} alt="" />
      </a>
    </div>
  );
};

export default RewardCard;
